var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 10L15.7071 10.7071C16.0976 10.3166 16.0976 9.68342 15.7071 9.29289L15 10ZM7.29289 16.2929C6.90237 16.6834 6.90237 17.3166 7.29289 17.7071C7.68342 18.0976 8.31658 18.0976 8.70711 17.7071L7.29289 16.2929ZM8.70711 2.29289C8.31658 1.90237 7.68342 1.90237 7.29289 2.29289C6.90237 2.68342 6.90237 3.31658 7.29289 3.70711L8.70711 2.29289ZM1 9C0.447715 9 0 9.44771 0 10C0 10.5523 0.447715 11 1 11V9ZM14.5 11C15.0523 11 15.5 10.5523 15.5 10C15.5 9.44771 15.0523 9 14.5 9V11ZM20 1C20 0.447715 19.5523 0 19 0C18.4477 0 18 0.447715 18 1H20ZM18 19C18 19.5523 18.4477 20 19 20C19.5523 20 20 19.5523 20 19H18ZM14.2929 9.29289L7.29289 16.2929L8.70711 17.7071L15.7071 10.7071L14.2929 9.29289ZM15.7071 9.29289L8.70711 2.29289L7.29289 3.70711L14.2929 10.7071L15.7071 9.29289ZM1 11H14.5V9H1V11ZM18 1V19H20V1H18Z",
    fill: "#0A0C0B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/ArrowRight.7d980801996a3c588ef6e02fc2f0e64e.svg";
export { ForwardRef as ReactComponent };